/**
 * @generated SignedSource<<d055b7c404b56ce2520e073993650988>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorLanguageButton_text$data = {
  readonly blocks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly data: string | null;
        readonly locale: Locale;
      };
    }>;
  };
  readonly " $fragmentType": "EditorLanguageButton_text";
};
export type EditorLanguageButton_text$key = {
  readonly " $data"?: EditorLanguageButton_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorLanguageButton_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorLanguageButton_text",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TextBlockConnection",
      "kind": "LinkedField",
      "name": "blocks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TextBlockEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TextBlock",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "locale",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Text",
  "abstractKey": null
};

(node as any).hash = "20d510cc5eaaec6039d46d88f8c33156";

export default node;
